<template>
    <div>

        <div class="timeseries-table-container table-responsive pre-scrollable">
            <table class="table table-sm card-table table-striped table-hover table-vcenter" v-if="tableData.length > 0" ref="export">
                
                <tbody>
                    <tr v-for="(dataSet, idx) in tableData[0].labels" :key="idx">
                        <td>{{idx}}</td>
                        <td>{{ tableData[0].labels[idx] }}</td>
                        <td>{{ tableData[0].data[idx] }}</td>
                    </tr>
                </tbody>
            </table>
            <div v-else>
                <p class="text-center">Oops, no data to display (yet).</p>
            </div>
        </div>

        <br>

    </div>
</template>

<script>
import Filters from '../mixins/Filters';
import HtmlTableToCsv from '../mixins/HtmlTableToCsvMixin';

export default {
    mixins: [
        Filters,
        HtmlTableToCsv,
    ],

    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/charts/DoughnatChartTableComponent.vue